import { Dimensions, StyleSheet } from 'react-native';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const styles = StyleSheet.create({
  container: {
    padding: 10,
    flex: IS_WEB ? null : 1,
  },
  tabsContainer: {
    height: Dimensions.get('window').height / 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  tabContainer: {
    flex: 1,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tab: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  tabText: {
    color: colors.darkGrey,
    fontSize: 13,
    textAlign: 'center',
    fontWeight: '500',
  },
  isTabActiveText: {
    color: colors.primary,
  },
  isTabActive: {
    borderBottomColor: 'red',
    borderBottomWidth: 1.5,
  },
});
